/* istanbul ignore file */
import React from "react";
import { ToelichtingOverlijdenHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import InkomensanalyseTabelOverlijden from "../../../scenarios/overlijden-drawer";
import { Chapter } from "../../../components/Chapter";
import Heading from "../../../components/Heading";
import { ReactElement } from "react-markdown/lib/react-markdown";
import { Motivering } from "../../../components/Motivering";

export const ScenarioOverlijdenChapter = ({
  scenarioOverlijden,
  selectedAanvrager,
}: {
  scenarioOverlijden: ToelichtingOverlijdenHoofdstuk;
  selectedAanvrager?: "Aanvrager1" | "Aanvrager2";
}): ReactElement => {
  const dashboardSettings = scenarioOverlijden.dashboard?.overlijden;

  const klantVolgNummer = selectedAanvrager === "Aanvrager2" ? 2 : 1;
  const motivering =
    scenarioOverlijden.motivering?.find(
      (x) => x.klantVolgnummer === klantVolgNummer
    ) || null;
  const isScenarioForAanvrager1 = selectedAanvrager === "Aanvrager1";

  const deceasedName = isScenarioForAanvrager1
    ? motivering?.klantNaamAanvrager || "Aanvrager"
    : motivering?.klantNaamPartner || "Partner";

  const motiveringKeuzes =
    selectedAanvrager === "Aanvrager1"
      ? scenarioOverlijden?.motiveringKeuzesAanvrager1
      : scenarioOverlijden?.motiveringKeuzesAanvrager2;

  return (
    <Chapter>
      <div className="break-avoid">
        <Heading level={3} text={`Bij overlijden van ${deceasedName}`} />
        <Motivering
          wens={motiveringKeuzes?.wensen ?? null}
          advies={motiveringKeuzes?.advies ?? null}
          keuze={motiveringKeuzes?.keuze ?? null}
        />
      </div>
      {motivering && dashboardSettings && (
        <InkomensanalyseTabelOverlijden
          motiveringOutput={motivering}
          dashboardSettings={dashboardSettings}
          selectedAanvrager={selectedAanvrager}
        />
      )}
    </Chapter>
  );
};
